(() => {
  if (window.__equjumpDesktopHoverMenuLoaded) return;
  window.__equjumpDesktopHoverMenuLoaded = true;

  const desktopHover = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  const selector = '.header__inline-menu details';
  const closeTimers = new WeakMap();

  const setOpen = (details, open) => {
    if (!details) return;

    const summary = details.querySelector(':scope > summary');

    if (open) {
      details.setAttribute('open', '');
      summary?.setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      summary?.setAttribute('aria-expanded', 'false');
    }
  };

  const closeOtherTopMenus = (current) => {
    document.querySelectorAll(selector).forEach((details) => {
      if (details === current) return;

      /* No cerramos ancestros/descendientes mientras se navega
         por un menú de varios niveles. */
      if (details.contains(current) || current.contains(details)) return;

      window.clearTimeout(closeTimers.get(details));
      setOpen(details, false);
    });
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll(selector).forEach((details) => {
      if (details.dataset.eqHoverInitialised === 'true') return;
      details.dataset.eqHoverInitialised = 'true';

      details.addEventListener('mouseenter', () => {
        if (!desktopHover.matches) return;

        window.clearTimeout(closeTimers.get(details));
        closeOtherTopMenus(details);
        setOpen(details, true);
      });

      details.addEventListener('mouseleave', () => {
        if (!desktopHover.matches) return;

        const timer = window.setTimeout(() => {
          setOpen(details, false);
        }, 180);

        closeTimers.set(details, timer);
      });
    });
  };

  /* En escritorio el hover despliega.
     El clic en una categoría PADRE navega a su URL.
     Para que funcione, el <summary> debe tener:
     data-eq-menu-url="{{ link.url }}"
  */
  document.addEventListener(
    'click',
    (event) => {
      if (!desktopHover.matches) return;

      const summary = event.target.closest(
        '.header__inline-menu details > summary[data-eq-menu-url]'
      );

      if (!summary) return;

      const url = summary.dataset.eqMenuUrl;
      if (!url || url === '#') return;

      event.preventDefault();
      event.stopPropagation();
      window.location.assign(url);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => initialise());

  document.addEventListener('shopify:section:load', (event) => {
    initialise(event.target);
  });

  desktopHover.addEventListener('change', (event) => {
    if (event.matches) {
      initialise();
      return;
    }

    document.querySelectorAll(selector).forEach((details) => {
      window.clearTimeout(closeTimers.get(details));
      setOpen(details, false);
    });
  });

  /* Por si el script se carga después de DOMContentLoaded. */
  if (document.readyState !== 'loading') {
    initialise();
  }
})();
